// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-59fbc3d3]{padding:5px 0 5px 0;min-width:100%;border:1px solid #ced4da}@media(min-width:0px){.grid-container[data-v-59fbc3d3]{display:grid;grid-template-columns:100%;gap:.5em}.grid-container div[data-v-59fbc3d3]{text-align:left}}@media(min-width:575px){.grid-container[data-v-59fbc3d3]{display:grid;grid-template-columns:50% 20% 20% 10%}}.icon[data-v-59fbc3d3]{margin-top:3px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
